import { ajaxDelete, fetchJson, postJson } from '@/util/helpers/ajax-helpers';
import { currentTimezone } from '@/util/helpers/time-helpers';
import { loading, completed, standardErrorHandler } from './helpers';
import {
  MODAL_DATA_LOADED,
  MODAL_SAVE_CLICKED,
  ALERTS_LOADED,
  ALERT_TAB_SWITCHED,
} from './constants';
import { changeTab } from './actions-misc';
import { ALERTS } from '../util/enums/views.constants';
import ModalAddAlert from '../components/modals/ModalAddAlert';
import { EMAIL } from '../util/AlertRef';

export function openAddAlertModal(existing, view, triggerType = EMAIL) {
  return (dispatch, getState) => {
    dispatch(loading(MODAL_DATA_LOADED));
    // first load list of views
    fetchJson('/views/find')
      .then((listOfViews) => {
        // then load list of possible recipients
        fetchJson(
          `/alerts/meta${!existing ? '' : `?existing=${existing.id()}`}`,
        )
          .then((meta) => {
            dispatch(
              completed(MODAL_DATA_LOADED, {
                modal: ModalAddAlert,
                existing,
                listOfViews,
                triggerType,
                meta,
                view,
                userEmail: getState().datasource.userEmail,
              }),
            );
          })
          .catch(standardErrorHandler(MODAL_DATA_LOADED, dispatch));
      })
      .catch(standardErrorHandler(MODAL_DATA_LOADED, dispatch));
  };
}

export function saveAlert(state) {
  return (dispatch) => {
    dispatch(completed(MODAL_SAVE_CLICKED, {})); // closes modal
    dispatch(loading(ALERTS_LOADED));
    postJson('/alerts', {
      _existingId: !state.existing ? null : state.existing.id(),
      _chosen: state.chosen, // ViewRef
      _frequency: state.frequency,
      _trigger: state.trigger,
      _showChanged: state.showChanged,
      _recipients: state.chosenRecipients,
      _timezone: currentTimezone(),
      _triggerType: state.triggerType,
    })
      .then((json) => {
        dispatch(changeTab(ALERTS)); // if alert tab isn't open, open it now
        dispatch(completed(ALERTS_LOADED, { json }));
      })
      .catch(standardErrorHandler(ALERTS_LOADED, dispatch));
  };
}

export function loadAlerts() {
  return (dispatch) => {
    dispatch(loading(ALERTS_LOADED));
    fetchJson('/alerts')
      .then((json) => {
        dispatch(completed(ALERTS_LOADED, { json }));
      })
      .catch(standardErrorHandler(ALERTS_LOADED, dispatch));
  };
}

export function deleteAlert(alertRef) {
  return (dispatch) => {
    dispatch(loading(ALERTS_LOADED));
    ajaxDelete(`/alerts/${alertRef.id()}`)
      .then((json) => {
        dispatch(completed(ALERTS_LOADED, { json }));
      })
      .catch(standardErrorHandler(ALERTS_LOADED, dispatch));
  };
}

export function switchAlertTab(tabName) {
  return (dispatch) => {
    dispatch(completed(ALERT_TAB_SWITCHED, { tabName }));
  };
}

export function disableAlert(alertRef) {
  return (dispatch) => {
    dispatch(loading(ALERTS_LOADED));
    // toggle disabled
    postJson(`/alerts/${alertRef.id()}/disable/${!alertRef.disabled()}`, {})
      .then((json) => {
        dispatch(completed(ALERTS_LOADED, { json }));
      })
      .catch(standardErrorHandler(ALERTS_LOADED, dispatch));
  };
}
